import React from "react";
import { cn } from "../../../utils/twMerge";

const SectionBgImg = ({ className }) => {
  return (
    <img
      src="/detail-result-bg.webp"
      alt="bg"
      className={cn(`w-full h-full absolute z-0 top-0 left-0 object-cover`, className)}
    />
  );
};

export default SectionBgImg;
